import { Stack } from "@/components/ui";
import { ChatCard } from "@/features/autorizacion/components/ChatCard";
import { FlujoCard } from "@/features/autorizacion/components/FlujoCard";
import type { SolicitudDetalle } from "@/lib/types";
import { RechazoBanner } from "./RechazoBanner";

/**
 * Vista enfocada cuando la solicitud está activamente en autorización
 * (sin tabs). Solo se muestra FlujoCard + ChatCard + (si aplica) el
 * banner de rechazo.
 */
export function EsperaDeAutorizacionView({ sol }: { sol: SolicitudDetalle }) {
  return (
    <Stack gap="md">
      {sol.estado === "RechazadaParaCorreccion" && sol.ultimoMotivoRechazo.length > 0 && (
        <RechazoBanner
          solicitudId={sol.id}
          solicitanteId={sol.solicitanteId}
          motivos={sol.ultimoMotivoRechazo}
          nivelDelRechazo={sol.flujo?.nivelActual ?? null}
        />
      )}
      {sol.flujo && <FlujoCard flujo={sol.flujo} />}
      <ChatCard solicitudId={sol.id} />
    </Stack>
  );
}
